import React, { useEffect, useRef } from 'react';
import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

export default function DonutChart({ active, inactive }) {
    const chartRef = useRef(null);

    useEffect(() => {
        // Create root element
        let root = am5.Root.new("chartdiv_donut");

        // Remove logo
        if (root._logo) root._logo.dispose();

        root.setThemes([am5themes_Animated.new(root)]);

        let chart = root.container.children.push(
            am5percent.PieChart.new(root, {
                radius: am5.percent(90),
                innerRadius: am5.percent(60), // Adjusted for better donut look
                layout: root.horizontalLayout
            })
        );

        // Use props for data
        let data = [
            { member: "Active", quantity: active || 0 },
            { member: "Inactive", quantity: inactive || 0 }
        ];

        let series = chart.series.push(
            am5percent.PieSeries.new(root, {
                name: "Series",
                valueField: "quantity",
                categoryField: "member"
            })
        );

        series.get("colors").set("colors", [
            am5.color(0x43861A), // Dark Green
            am5.color(0xE2EDAB), // Light Green
        ]);

        series.data.setAll(data);

        // Hide labels and ticks for the compact dashboard look
        series.labels.template.set("visible", false);
        series.ticks.template.set("visible", false);
        series.slices.template.set("strokeOpacity", 0);
        series.slices.template.set("fillGradient", am5.RadialGradient.new(root, {
            stops: [
                { brighten: -0.90 },
                { brighten: -0.8 },
                { brighten: -0.5 },
                { brighten: 0 },
                { brighten: -0.5 }
            ]
        }));


        // Animation
        series.appear(1000, 100);

        return () => {
            root.dispose();
        };
    }, [active, inactive]); // Re-run if props change

    return (
        <div id="chartdiv_donut" style={{ width: "100%", height: "100%" }}></div>
    );
}